var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1882_872",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#F8153B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1882_872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 16.6667C2.87508 16.6667 2.48272 16.5035 2.15633 16.1771C1.82994 15.8507 1.66675 15.4584 1.66675 15V5.00004C1.66675 4.54171 1.82994 4.14935 2.15633 3.82296C2.48272 3.49657 2.87508 3.33337 3.33341 3.33337H16.6667C17.1251 3.33337 17.5174 3.49657 17.8438 3.82296C18.1702 4.14935 18.3334 4.54171 18.3334 5.00004V15C18.3334 15.4584 18.1702 15.8507 17.8438 16.1771C17.5174 16.5035 17.1251 16.6667 16.6667 16.6667H3.33341ZM3.33341 15H16.6667V6.66671H3.33341V15ZM6.25008 14.1667L5.08341 13L7.22925 10.8334L5.06258 8.66671L6.25008 7.50004L9.58341 10.8334L6.25008 14.1667ZM10.0001 14.1667V12.5H15.0001V14.1667H10.0001Z",
    fill: "#F8153B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/Terminal.b47bba260647cfddfa5ffe6d1996d3f7.svg";
export { ForwardRef as ReactComponent };